module.exports = __webpack_public_path__ + "img/stamp-mydesign.d7139194.png";